export const API_URL = "http://genom23-dev.genomed.pl/api";
export default API_URL;


// WEBPACK FOOTER //
// ./src/common/config.js